import store from '../store';
import { geofenceToBounds } from './geofenceBounds';

// Central imperative map service. The active map host (OSM Map or MapGoogle)
// registers an engine adapter on mount; any component can then invoke map
// actions through mapController without importing map internals. With no map
// mounted, actions no-op.
//
// This is a minimal subset covering geofence framing only. It is shaped to
// match the fuller mapControl layer (zoomToDevice, popups, smoothFlyTo) so
// that porting the rest later extends this file rather than replacing it.
let activeAdapter = null;

export const registerMapAdapter = (adapter) => {
    activeAdapter = adapter;
    return () => {
        if (activeAdapter === adapter) {
            activeAdapter = null;
        }
        if (adapter.dispose) {
            adapter.dispose();
        }
    };
};

const getGeofence = (geofenceId) => store.getState().geofences.items[geofenceId];

export const mapController = {
    // Fit the viewport to an engine-neutral { north, south, east, west } box.
    fitBoundingBox(bounds, options) {
        return activeAdapter && activeAdapter.fitBoundingBox(bounds, options);
    },

    // Frame a geofence's full extent (GeofencesList row click). Resolves the
    // geofence from the store so callers only need to pass an id.
    async zoomToGeofence(geofenceId) {
        if (!activeAdapter) return;
        const geofence = getGeofence(geofenceId);
        if (!geofence) return;
        const bounds = geofenceToBounds(geofence);
        // Unparseable/empty area: leave the camera where it is.
        if (!bounds) return;
        await activeAdapter.fitBoundingBox(bounds);
    },
};
